import UserForm from '../components/Form'
import useModalForm from '../../../@hooks/useModalForm'
import UserService from '../../../@services/user'

export default function useCreateRole(cb) {
  const { open } = useModalForm(UserForm)

  const openDialog = () => {
    return open(
      async req => {
        const res = await UserService.create({ ...req })
        if (typeof cb === 'function') {
          cb(res)
        }
      },
      {
        stores: [],
        status: 1,
        type: 2,
      },
      {
        title: '添加用户',
        bodyStyle: { maxHeight: '400px', overflow: 'auto' },
        width: '680px',
      }
    )
  }

  return openDialog
}
